import { configureStore } from '@reduxjs/toolkit';
import globalReducer from './data/global';

export const store = configureStore({
  reducer: {
    global: globalReducer, // 确保这里正确配置
  },
});

export default store;